import { defineStore } from 'pinia';
import { ArchiveTheSelectedAggregateIdsCommand } from 'src/stores/archive/commands/ArchiveTheSelectedAggregateIdsCommand';
import { DearchiveTheSelectedAggregateIdsCommand } from 'src/stores/archive/commands/DearchiveTheSelectedAggregateIdsCommand';

import type { ArchiveCommandPayload } from './interfaces';

export const useArchiveStore = defineStore('archive', {
	actions: {
		archiveSelectedAggregateIds(payload: ArchiveCommandPayload): void {
			void payload.commandBus?.sendCommand(new ArchiveTheSelectedAggregateIdsCommand(payload.aggregateIds));
		},
		deArchiveSelectedAggregateIds(payload: ArchiveCommandPayload): void {
			void payload.commandBus?.sendCommand(new DearchiveTheSelectedAggregateIdsCommand(payload.aggregateIds));
		},
	},
	state: () => ({}),
});
export * from './interfaces';
export * from './types';
